var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCellphoneWireless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.07 4.93A9.969 9.969 0 0123 12c0 2.76-1.12 5.26-2.93 7.07l-1.41-1.41A7.938 7.938 0 0021 12c0-2.21-.89-4.22-2.34-5.66l1.41-1.41m-2.83 2.83A5.98 5.98 0 0119 12c0 1.65-.67 3.15-1.76 4.24l-1.41-1.41A3.99 3.99 0 0017 12c0-1.11-.45-2.11-1.17-2.83l1.41-1.41M13 10a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2m-1.5-9A2.5 2.5 0 0114 3.5V8h-2V4H3v15h9v-3h2v4.5a2.5 2.5 0 01-2.5 2.5h-8A2.5 2.5 0 011 20.5v-17A2.5 2.5 0 013.5 1h8z"
  })));
}

export default SvgCellphoneWireless;